import type { GQL_ID } from '@@partner:types:graphql'
import type { Category } from '@@partner:types:app'

import React, { useCallback, useState, useEffect } from 'react'
import { useCategoriesFetcher } from '@@partner:graphql/query/catalog/categoriesWithParent.gql'

import { Cascader } from 'rsuite'
import { ItemDataType } from 'rsuite/esm/MultiCascadeTree'
export interface CategoryParentSelectorProps {
  skipIds?: GQL_ID[]
  value?: GQL_ID
  onChange?: (newParent: Category) => void
}

const mapToItemDataType = (category: Category) => ({
  label: category.name,
  value: category.id,
  children: [],
  loading: false,
  parent_id: category.parent_id,
  __category: category
})

export default function CategoryParentSelector ({
  skipIds,
  value,
  onChange
}: CategoryParentSelectorProps) {
  const [ data, setData ] = useState<ItemDataType[]>([])
  const [ state, setState ] = useState<GQL_ID | undefined>(value)

  const { fetchCategories, fetchRootCategories } = useCategoriesFetcher()

  useEffect(() => {
    const preload = async (id: GQL_ID | undefined) => {
      const initial = await fetchRootCategories({ skipIds })
      setData(initial.categories.edges.map(mapToItemDataType))
    }

    preload(value)
  }, [])

  const handleGetChildren = async (node: ItemDataType) => {
    if (node.value) {
      const data = await fetchCategories({
        parentId: node.value,
        skipIds
      })

      return data.categories.edges.map(mapToItemDataType)
    }

    return []
  }

  const handleChange = (category: ItemDataType) => {
    setState(category.value)
    onChange?.(category.__category)
  }

  return (
    <div>
      {/* {JSON.stringify(data)} */}
      <Cascader
        inline
        block
        searchable
        data={data}
        value={state}
        getChildren={handleGetChildren}
        onSelect={handleChange}
        columnWidth={280}
        columnHeight={400}
      />
    </div>
  )
}
